<div class="recipe-detail-page">

  <div *ngIf="loading" class="loading-state">Loading...</div>

  <div *ngIf="!loading && recipe">

    <!-- Back + header -->
    <div class="detail-header">
      <button class="back-btn" (click)="goBack()">← Back</button>
      <div class="detail-title-row">
        <div>
          <h1 class="detail-name">{{ recipe.name }}</h1>
          <p class="detail-attribution">Added by {{ recipe.addedBy }}</p>
        </div>
        <a *ngIf="recipe.link" [href]="recipe.link" target="_blank" rel="noopener noreferrer"
           class="btn btn-outline-success btn-sm link-btn">
          View Source ↗
        </a>
      </div>
    </div>

    <!-- Fields -->
    <div class="detail-body">
      <div class="detail-field" *ngIf="recipe.cuisine">
        <span class="field-label">Cuisine</span>
        <span class="cuisine-pill">{{ recipe.cuisine }}</span>
      </div>

      <div class="detail-field" *ngIf="recipe.feelings.length > 0">
        <span class="field-label">Feelings</span>
        <div class="tag-row">
          <span class="feeling-tag" *ngFor="let f of recipe.feelings">{{ f }}</span>
        </div>
      </div>

      <div class="detail-field" *ngIf="recipe.ingredients.length > 0">
        <span class="field-label">Ingredients</span>
        <div class="tag-row">
          <span class="ingredient-tag" *ngFor="let i of recipe.ingredients">{{ i }}</span>
        </div>
      </div>

      <div class="detail-field" *ngIf="recipe.notes">
        <span class="field-label">Notes</span>
        <p class="notes-text">{{ recipe.notes }}</p>
      </div>
    </div>

    <!-- Footer actions -->
    <div class="detail-footer">
      <button class="btn btn-outline-danger" (click)="deleteRecipe()">Delete</button>
      <button class="btn btn-success" (click)="openEditModal()">Edit</button>
    </div>

  </div>

  <!-- Edit form modal -->
  <app-recipe-form
    *ngIf="showFormModal && recipe"
    [recipe]="recipe"
    (saved)="onFormSaved()"
    (cancelled)="onFormCancelled()">
  </app-recipe-form>

</div>
